import { PanelErrorBoundary } from "@/components/panel-error-boundary"
import { createFileRoute } from "@tanstack/react-router"
import { OrderDetailContent } from "@/features/orders/order-detail-content"

export const Route = createFileRoute("/dashboard/orders/$orderId")({
	component: OrderDetailPage,
})
function OrderDetailPage() {
	const { orderId } = Route.useParams()
	return (
		<PanelErrorBoundary title="Order details" resetKey={orderId}>
			<OrderDetailContent orderId={orderId} />
		</PanelErrorBoundary>
	)
}
